import {Project} from '@/domain/entities/Project';
import projectRepository from '@/domain/repository/ProjectRepository';

export const getAllProjects = async (): Promise<Array<Project>> => {
  try {
    return projectRepository.getProjects();
  } catch (error) {
    console.error('Error fetching projects', error);
    return [];
  }
};